import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@mui/material";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import PrimaryButton from "../../shared/Buttons/PrimaryButton";
import SecondaryButton from "../../shared/Buttons/SecondaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import {
  Desktop,
  Megaphone,
  UsersThree,
  HandHeart,
  LinkedinLogo,
} from "@phosphor-icons/react";

export default function AboutUs() {
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedTeamMember) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [selectedTeamMember]);

  const aboutUs =
    "At Sponsor a Pet, we're dedicated to giving animal rescues a platform to share their stories and connect with animal lovers like you. Our mission is simple yet powerful: to provide every animal with a loving environment they can call home, ensuring their basic needs are met and advocating for the end of kill shelters, animal abuse, and habitat destruction.";

  const ourMission =
    "To provide every animal a loving environment that they can call home. Every animal deserves the opportunity to have their basic needs met; food, medicine, a safe and loving family. Our goals are to eliminate Kill Shelters, Animal Abuse, and destruction of animal habitats. We strive to share positive and uplifting stories of animals who need our help, and give thanks to the donors who help animals find their forever home. Support the 30+ Organizations that choose to fundraise with us!";
  const howWeAreDifferent =
    "We work hand in hand with passionate local organizations, amplifying our impact in communities as we unite under one common goal. Our platform highlights Animal Non-Profits' stories of positivity and laughter by uplifting animals in need while expressing gratitude to the tireless volunteers who help these animals find their forever homes.";
  const getInvolved =
    "Signing up as one of our members as a PetStar is a great start. On top of that, there's much more you can do to get involved. The easiest way is to share your story with us. We would love to hear from you and share your story. What drives your passion for animals and a little about your background. Another way would be to share local organizations that need our help, or local communities who would want to get involved. Our goal is to provide a platform for animals, non-profits, Individuals, and companies alike.";

  const providingPlatform =
    "We support 40+ animal rescues to share their stories and connect with animal lovers, increasing visibility for these nonprofits and the animals they care for.";
  const amplifyingImpact =
    "By partnering with dedicated local organizations, we have increased our community impact, striving to provide every animal with a loving home while eliminating kill shelters and habitat destruction.";
  const fosteringCommunity =
    "We have built a community of compassionate individuals dedicated to helping animals in need. By sharing uplifting stories, we've cultivated a supportive environment for animal welfare.";
  const advocacyAwareness =
    "We advocate for animal rights and raise awareness about important issues such as the troubles of animals in shelters and the need for responsible pet ownership.";
  const openPositions =
    "If you're inspired by our mission and want to make a difference, we invite you to join our community. Together, we're a team of passionate individuals with a shared vision of helping all animals. By coming together and moving in the same direction, we can create a lasting impact in communities across the country. Join us at Sponsor a Pet, and let's make a difference together.";

  const teamMembers = [
    {
      name: "Scott DeFries",
      title: "Founder & CEO",
      linkedin: "https://www.linkedin.com/in/scottie-defries-57420a3a/",
      description: (
        <>
          With over 20 years of experience in the technology industry, Scottie
          DeFries has built a distinguished career developing and implementing
          strategic initiatives for leading global enterprises. As a pioneer in
          innovative technology solutions, Scottie has created industry
          standards that have transformed operations at an enterprise-wide
          scale. But beyond his tech expertise, Scottie is driven by a deep
          passion for animal welfare. As the{" "}
          <span className="font-bold">Founder and CEO of Sponsor a Pet</span>,
          Scottie has channeled his extensive background in strategic planning
          into a mission to create lasting change for animals in need.
          <br />A lifelong animal lover and devoted{" "}
          <span className="font-bold">Cat Dad</span>, Scottie has always
          believed in the power of community and compassion. His experience in
          the tech world revealed a significant gap in the animal rescue
          industry—too many services and unnecessary costs were taking resources
          away from saving lives. Inspired by this realization, Scottie
          envisioned Sponsor a Pet as a platform that could streamline essential
          resources for rescues, cutting out the middleman and reducing costs to
          maximize the impact of every donation.
          <br />
          In addition to his work with animals, Scottie is a proud{" "}
          <span className="font-bold">father and philanthropist</span>, always
          seeking new ways to give back and advocate for causes he believes in.
          His long-standing commitment to advocacy has raised significant funds
          for 501(c)(3) organizations dedicated to animal rescue and welfare.
          Under Scottie's leadership, Sponsor a Pet is revolutionizing how
          nonprofits approach fundraising, crafting uplifting, compelling
          messages that resonate with audiences everywhere and, most
          importantly, save lives.
        </>
      ),
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/our-team-images/scott.png",
      image_no_padding:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/our-team-images/scott-2.jpg",
    },
    {
      name: "Rohit Kaushik",
      title: "Founding Engineer",
      linkedin: "https://www.linkedin.com/in/rkaushik29/",
      description:
        "Rohit is a serial entrepreneur with a proven track record of turning startups into thriving businesses. With a background in Computer Science, he has expertly scaled infrastructures to support thousands of users on both web and mobile platforms. His ventures have garnered attention from prestigious journals and competitions, including TechCrunch's 'Disrupt.' Through developing modern applications that cater to user needs, Rohit has amplified revenue streams and secured Seed and Series A funding rounds for multiple companies. His relentless curiosity drives him to deeply understand the industries he enters, always with a keen eye for growth opportunities. At Sponsor a Pet, Rohit's love for animals converges with his technical expertise. He has developed a rapidly growing fundraising platform and app in the pet and animal industry, supporting a thriving ecosystem of nonprofits in their fundraising and community engagement efforts. He also leads the technology consulting services of the company.",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/our-team-images/rohit.png",
      image_no_padding:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/our-team-images/rohit-2.jpeg",
    },
  ];

  return (
    <div className="w-full mt-24">
      {/* Hero About Us section */}
      <section className="flex flex-col md:flex-row justify-between items-center w-full lg:px-20 px-8 xl:px-32 py-6 lg:py-12 xl:py-20 mx-auto gap-4 overflow-x-hidden">
        <div className="max-w-[1360px] w-full mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-12 lg:gap-20 xl:gap-[165px]">
          <div className="w-full md:w-1/2 text-left">
            {/* Screen reader label */}
            <h1 className="sr-only">ABOUT US</h1>

            {/* Visual label */}
            <p className="text-blue !font-montserrat font-bold mb-2 text-left">
              ABOUT US
            </p>
            <h2 className="text-orange !text-4xl md:!text-5xl !font-poppins !font-semibold mb-6 text-left">
              Together We Rescue
            </h2>
            <p className="!text-lg md:!text-xl font-medium mb-6 text-left">
              {aboutUs}
            </p>
          </div>
          <div className="w-full md:w-auto flex justify-center">
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/1.png"
              alt="About Sponsor a Pet"
              className="shadow-lg rounded-xl max-w-[300px] sm:max-w-[350px] md:max-w-[454px] h-auto"
            />
          </div>
        </div>
      </section>

      {/* How We Are Different section */}
      <section className="flex flex-col items-center w-full lg:px-20 px-8 xl:px-32 py-6 lg:py-12 xl:py-20 mx-auto overflow-x-hidden">
        <div className="max-w-[1360px] w-full mx-auto relative">
          {/* Left SVG */}
          <div className="absolute left-0 top-0 transform -translate-y-1/2 -translate-x-8 hidden lg:block">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="69"
              height="79"
              viewBox="0 0 69 79"
              fill="none"
            >
              <path
                d="M47.6275 41.1313L2.96007 24.2769M66.5194 21.5457C64.6751 20.3964 59.1605 14.9809 51.8562 2.51305M43.822 67.9038C39.0905 69.986 28.055 74.571 21.7648 76.2542"
                stroke="#FE994F"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {/* Right SVG */}
          <div className="absolute right-0 top-full transform -translate-y-1/2 translate-x-8 hidden lg:block">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="61"
              viewBox="0 0 68 61"
              fill="none"
            >
              <path
                d="M27.5 24.5L60.5 59M2 34C3.16667 35.8333 5.8 43.1 7 57.5M42.5 2C47.6667 2.16667 59.6 2.8 66 4"
                stroke="#FE994F"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {/* Center Content */}
          <div className="text-center max-w-7xl mx-auto px-4">
            <p className="!text-lg md:!text-xl font-medium !font-montserrat  leading-relaxed">
              {howWeAreDifferent}
            </p>
          </div>
        </div>
      </section>

      {/* Our Accomplishments section */}
      <section className="flex flex-col items-center w-full lg:px-20 px-8 xl:px-32 py-6 lg:py-12 xl:py-20 mx-auto overflow-x-hidden">
        <div className="max-w-[1360px] w-full mx-auto flex flex-col md:flex-row justify-between items-start gap-6 md:gap-12 lg:gap-20 xl:gap-[155px]">
          {/* Left side - Images */}
          <div className="w-full md:w-2/5 flex flex-col gap-4 order-2 md:order-1 items-center md:items-start">
            <div
              className="rounded-xl overflow-hidden shadow-lg w-full flex items-center justify-center"
              style={{
                maxWidth: "462px",
                height: "173px",
                maxHeight: "173px",
              }}
            >
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/2.png"
                alt="Pomeranian dog"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div
              className="rounded-xl overflow-hidden shadow-lg w-full flex items-center justify-center"
              style={{
                maxWidth: "462px",
                height: "173px",
                maxHeight: "173px",
              }}
            >
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/3.png"
                alt="Dog and cat together"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div
              className="rounded-xl overflow-hidden shadow-lg w-full flex items-center justify-center"
              style={{
                maxWidth: "462px",
                height: "173px",
                maxHeight: "173px",
              }}
            >
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/4.png"
                alt="White cat with blue eyes"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="w-full md:w-3/5 text-left order-1 md:order-2 md:pl-6">
            <h2 className="text-orange !text-3xl !font-poppins !font-semibold mb-12 text-left">
              Our Accomplishments
            </h2>

            <div className="space-y-6 text-left">
              <div className="flex items-start gap-4 mb-10 md:gap-8 lg:gap-16">
                <div className="bg-blue text-white p-4 rounded-full flex-shrink-0">
                  <Desktop size={24} className="text-white" />
                </div>
                <div className="text-left -mt-4">
                  <h3 className="font-semibold !font-montserrat text-lg mb-2 text-left">
                    Providing a Platform
                  </h3>
                  <p className="!text-sm font-medium md:!text-base max-w-[600px] !font-montserrat text-left">
                    {providingPlatform}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-8 lg:gap-16">
                <div className="bg-blue text-white p-4 rounded-full flex-shrink-0">
                  <Megaphone size={24} className="text-white" />
                </div>
                <div className="text-left -mt-4">
                  <h3 className="font-semibold !font-montserrat text-lg mb-2 text-left">
                    Amplifying Impact
                  </h3>
                  <p className="!text-sm font-medium md:!text-base max-w-[600px] !font-montserrat text-left">
                    {amplifyingImpact}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-8 lg:gap-16">
                <div className="bg-blue text-white p-4 rounded-full flex-shrink-0">
                  <UsersThree size={24} className="text-white" />
                </div>
                <div className="text-left -mt-4">
                  <h3 className="font-semibold !font-montserrat text-lg mb-2 text-left">
                    Fostering Community
                  </h3>
                  <p className="!text-sm font-medium md:!text-base max-w-[600px] !font-montserrat text-left">
                    {fosteringCommunity}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-8 lg:gap-16">
                <div className="bg-blue text-white p-4 rounded-full flex-shrink-0">
                  <HandHeart size={24} className="text-white" />
                </div>
                <div className="text-left -mt-4">
                  <h3 className="font-semibold !font-montserrat text-lg mb-2 text-left">
                    Advocacy and Awareness
                  </h3>
                  <p className="!text-sm font-medium md:!text-base max-w-[600px] !font-montserrat text-left">
                    {advocacyAwareness}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Get Involved section */}
      <div className="flex flex-col md:flex-row justify-between items-center w-full lg:px-20 px-8 xl:px-32 py-6 lg:py-12 xl:py-20 mx-auto gap-4 overflow-x-hidden">
        <div className="max-w-[1360px] w-full mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-12 lg:gap-20 xl:gap-[165px]">
          <div className="w-full md:w-1/2 text-left">
            <h2 className="text-orange !text-4xl md:!text-5xl !font-poppins !font-semibold mb-6 text-left">
              Get Involved
            </h2>
            <p className="!text-lg md:!text-xl font-medium mb-6 text-left">
              {getInvolved}
            </p>
            <div className="text-left">
              <Link
                to="/petstar"
                onClick={() => window.scrollTo(0, 0)}
                className="bg-blue hover:bg-blue-dark1 text-white text-sm shadow-xl transition-all duration-300 font-semibold py-2 px-6 rounded-full inline-block"
              >
                Join The PetStar Club
              </Link>
            </div>
          </div>
          <div className="w-full md:w-auto flex justify-center gap-4">
            <div
              className="rounded-xl overflow-hidden shadow-lg flex items-center justify-center"
              style={{
                width: "219px",
                height: "405px",
                maxWidth: "219px",
                maxHeight: "405px",
              }}
            >
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/5.png"
                alt="Person with dog in nature"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div
              className="rounded-xl overflow-hidden shadow-lg flex items-center justify-center"
              style={{
                width: "219px",
                height: "405px",
                maxWidth: "219px",
                maxHeight: "405px",
              }}
            >
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/about-us/6.png"
                alt="Woman holding cat"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Meet the Team section */}
      <section className="flex flex-col items-center w-full lg:px-20 px-8 xl:px-32 py-6 lg:py-12 xl:py-20 mx-auto overflow-x-hidden">
        <div className="max-w-[1360px] w-full mx-auto text-center">
          {/* Screen reader label */}
          <h2 className="sr-only">MEET THE TEAM</h2>

          {/* Visible label */}
          <p className="text-blue !font-montserrat font-bold mb-2">
            MEET THE TEAM
          </p>
          <h3 className="text-orange !text-3xl  !font-poppins !font-semibold mb-12  mx-auto">
            Our Passionate Team Is Dedicated To Improving The Lives Of Animals
            In Need
          </h3>

          <div className="flex flex-wrap justify-center gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 relative overflow-hidden cursor-pointer"
                style={{ width: "278px", height: "306px" }}
                onClick={() => setSelectedTeamMember(member)}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{
                    objectPosition:
                      member.name === "Scott DeFries" ? "center 60%" : "center",
                  }}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <h4
                        className="!font-montserrat text-left !text-lg !font-semibold mb-1 text-white"
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          lineHeight: "normal",
                        }}
                      >
                        {member.name}
                      </h4>
                      <p
                        className="!font-montserrat text-left text-white"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "normal",
                        }}
                      >
                        {member.title}
                      </p>
                    </div>
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center"
                      onClick={(e) => e.stopPropagation()}
                      aria-label={`View ${member.name}'s Linkedin profile`}
                    >
                      <LinkedinLogo
                        size={28}
                        weight="bold"
                        className="text-white hover:text-blue-300 transition-colors duration-300"
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal for team member details */}
      {selectedTeamMember && (
        <div className="modal-background">
          <div className="m-auto w-11/12 sm:w-96 md:w-4/5 h-96 sm:h-fit bg-white opacity-100 rounded-2xl flex flex-col p-4">
            <FontAwesomeIcon
              icon={faX}
              onClick={() => setSelectedTeamMember(null)}
              className="cursor-pointer ml-auto text-grey"
            />
            <div className="flex flex-col sm:flex-row justify-center items-start gap-8 max-h-[600px] min-h-0 overflow-auto lg:overflow-hidden">
              {/* Image Section */}
              <div className="flex flex-col w-36 sm:w-96 gap-8 mx-auto sm:mt-0">
                <img
                  src={selectedTeamMember.image_no_padding}
                  className="w-96 h-auto object-cover"
                  alt={selectedTeamMember.name}
                />
                <a
                  href={selectedTeamMember.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    className="text-3xl sm:text-5xl"
                  />
                </a>
              </div>

              {/* Description Section with scrolling enabled */}
              <div className="flex flex-col w-full lg:w-9/12 max-h-[500px] lg:overflow-auto min-h-0">
                <h2 className="text-left text-3xl font-medium">
                  {selectedTeamMember.name}
                </h2>
                <p className="text-left font-normal mb-8">
                  {selectedTeamMember.title}
                </p>
                <h3 className="text-base sm:text-2xl text-black md:mb-4 text-left">
                  {selectedTeamMember.description}
                </h3>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
